
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import RemoteConnection from '@/models/RemoteConnection'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import Widget from '@/components/Widget/Widget.vue'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import SelectOption from '@/models/interface/SelectOption'
import WebMessage from '@/models/WebMessage'

@Component({
  components: {
    SelectPicker,
    FormInput,
    Widget,
    FooterNav,
  },
})
export default class RemoteConnectionEdit extends ViewModel {
  @Ref() readonly validator!: any

  public remote_connection: RemoteConnection = new RemoteConnection()

  public loading: boolean = true

  public disabled: boolean = false

  public file: any = null

  public include_bundle: SelectOption[] = []

  public include_open_measurement: SelectOption[] = []

  public include_teams_ids: SelectOption[] = []

  public mounted() {
    if (this.$route.params.id) {
      RemoteConnection.find(this.$route.params.id).then(response => {
        this.remote_connection = response
        this.generateUsedTags()
        this.loading = false
      })
    } else {
      this.loading = false
    }
  }

  public generateUsedTags() {
    if (this.remote_connection.metadata.content_targeting?.include_bundle) {
      this.include_bundle = this.remote_connection.metadata.content_targeting.include_bundle.map(
        (tag: any) => new SelectOption(tag, tag),
      )
    }

    if (this.remote_connection.metadata.open_measurement) {
      this.include_open_measurement = this.remote_connection.metadata.open_measurement.map(
        (tag: any) => new SelectOption(tag, tag),
      )
    }
    if (this.remote_connection.metadata.team_ids) {
      this.include_teams_ids = this.remote_connection.metadata.team_ids.map(
        (tag: any) => new SelectOption(tag, tag),
      )
    }
  }

  public get useCredentials() {
    if (!this.selectedOption) return false
    return this.selectedOption.value === 'gam'
  }

  public get selectedOption() {
    if (!this.remote_connection.driver ?? !this.remote_connection.driver.length) {
      return false
    }

    return this.remote_connection_options.find(
      (option: any) => option.value === this.remote_connection.driver,
    )
  }

  public get remote_connection_options() {
    return RemoteConnection.drivers
  }

  public get types() {
    return RemoteConnection.types
  }

  public checkIfAdserverType(cllbk: any) {
    if (this.remote_connection.type !== 'adserver') {
      cllbk()
      return
    }
    WebMessage.confirm(
      'Are you sure that you want to add a new adserver? Once the connection is created we will automatically import all your existing orders and line items.',
      'Add Adserver',
      {
        okTitle: 'Yes',
      },
    ).then(result => {
      if (result) {
        cllbk()
      }
    })
  }

  public save() {
    this.checkIfAdserverType(() => {
      if (this.useCredentials && this.file === null && !this.$route.params.id) {
        WebMessage.error('Please upload the credentials file.')
        return
      }
      this.loading = true
      this.remote_connection.save(this.file).then(res => {
        this.loading = false
        if ([200, 201].includes(res.status)) {
          this.$router.push({ name: 'remote-connections' })
        }
      })
    })
  }

  public addContentTarget(new_tag: any) {
    this.include_bundle.push(new SelectOption(new_tag, new_tag))

    if (!this.remote_connection.metadata.content_targeting) {
      this.remote_connection.metadata.content_targeting = {
        include_bundle: [],
      }
    }
    this.remote_connection.metadata.content_targeting.include_bundle.push(new_tag)
  }

  public addOpenMeasurement(new_tag: any) {
    this.include_open_measurement.push(new SelectOption(new_tag, new_tag))
    if (!this.remote_connection.metadata.open_measurement) {
      this.remote_connection.metadata.open_measurement = []
    }
    this.remote_connection.metadata.open_measurement.push(new_tag)
  }

  public addTeamsId(new_tag: any) {
    this.include_teams_ids.push(new SelectOption(new_tag, new_tag))
    if (!this.remote_connection.metadata.team_ids) {
      this.remote_connection.metadata.team_ids = []
    }
    this.remote_connection.metadata.team_ids.push(new_tag)
  }
}
